module.exports = __webpack_public_path__ + "static/media/tv2.8e7dbd82.jpg";